import {
  Box,
  CardContent,
  Card,
  Stack,
  Stepper,
  Tabs,
  Tab,
} from "@mui/material";
import { useState, useContext } from "react";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import GeneralInfo from "./GeneralInfo";
import { useFormik } from "formik";
import { TransferReasonTypes } from "./Types";
import VehicleAddPage from "./VehicleAddPage";
import DriverAddPage from "./DriverAddPage";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import dayjs from "dayjs";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";

interface Props {
  setPage: (value: boolean) => void;
  updateDatasourceAcriss: () => void;
  initialFormikValue: any;
  tenant: string;
}

const AddEditTransferReasonPage = (props: Props) => {
  const t = useOperationTranslation();
  const [activeStep, setActiveStep] = useState(0);
  const [weight, setWeight] = useState<number>(0);
  const [value, setValue] = useState("generalInfo");
  const [changeStartStation, setChangeStartStation] = useState<boolean>(false);
  const [minDateTime, setMinDateTime] = useState(dayjs(new Date()));
  const [changeTransportationType, setChangeTransportationType] =
    useState<boolean>(false);
  const [isCheck, setIsCheck] = useState<boolean>(false);
  const { globalData } = useContext(GlobalContext);
  const [user, setUser] = useState<any>(globalData.user);

  const formik = useFormik<TransferReasonTypes.AddFunctionTypes>({
    initialValues: {
      id: props.initialFormikValue.id,
      transferReasonCode: props.initialFormikValue.transferReasonCode,
      status: props.initialFormikValue.status,
      startStationId: props.initialFormikValue.startStationId,
      startStationType: props.initialFormikValue.startStationType,
      startDate: props.initialFormikValue.startDate,
      expectedEndStationId: props.initialFormikValue.expectedEndStationId,
      expectedEndDate: props.initialFormikValue.expectedEndDate,
      endStationId: props.initialFormikValue.endStationId,
      endDate: props.initialFormikValue.endDate,
      note: props.initialFormikValue.note,
      operatorCode: user.username,
      companyName: props.initialFormikValue.companyName,
      companyCity: props.initialFormikValue.companyCity,
      plates: [""],
      driversId: [...props.initialFormikValue.driversId, ""],
      transferType: props.initialFormikValue.transferType,
      shopRepairLms: props.initialFormikValue.shopRepairLms,
    },
    onSubmit: () => {},
  });

  const navigateBack = () => {
    setChangeStartStation(false);
    setChangeTransportationType(false);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const createButton = () => {
    if (activeStep == 0) {
      return (
        <GeneralInfo
          handleNext={handleNext}
          setPage={props.setPage}
          updateDatasourceAcriss={props.updateDatasourceAcriss}
          formik={formik}
          tenant={props.tenant}
          setChangeStartStation={setChangeStartStation}
          setChangeTransportationType={setChangeTransportationType}
          setMinDateTime={setMinDateTime}
          minDateTime={minDateTime}
        />
      );
    } else if (activeStep == 1) {
      return (
        <VehicleAddPage
          formik={formik}
          setPage={props.setPage}
          navigateBack={navigateBack}
          handleNext={handleNext}
          tenant={props.tenant}
          changeStartStation={changeStartStation}
          changeTransportationType={changeTransportationType}
          setWeight={setWeight}
          updateDatasourceAcriss={props.updateDatasourceAcriss}
          weight={weight}
        />
      );
    } else if (activeStep == 2) {
      return (
        <DriverAddPage
          formik={formik}
          navigateBack={navigateBack}
          changeTransportationType={changeTransportationType}
          setPage={props.setPage}
          updateDatasourceAcriss={props.updateDatasourceAcriss}
          tenant={props.tenant}
          isCheck={isCheck}
        />
      );
    }
  };

  // const editButton = () => {
  //   if (value == "generalInfo") {
  //     return (
  //       <GeneralInfo
  //         handleNext={handleNext}
  //         setPage={props.setPage}
  //         updateDatasourceAcriss={props.updateDatasourceAcriss}
  //         formik={formik}
  //         tenant={props.tenant}
  //       />
  //     );
  //   }
  //   if (value == "vehicle") {
  //     return (
  //       <VehicleAddPage
  //         formik={formik}
  //         setPage={props.setPage}
  //         navigateBack={navigateBack}
  //         handleNext={handleNext}
  //         tenant={props.tenant}
  //       />
  //     );
  //   }

  //   if (value == "driver") {
  //     return (
  //       <DriverAddPage
  //         formik={formik}
  //         navigateBack={navigateBack}
  //         setPage={props.setPage}
  //         updateDatasourceAcriss={props.updateDatasourceAcriss}
  //         tenant={props.tenant}
  //       />
  //     );
  //   }
  // };

  return (
    <>
      <Box className="carBrandOuterTableBox">
        {formik.values.id == "" ? (
          <Box>
            <Stack mb="32px">
              <Stepper
                activeStep={activeStep}
                sx={{
                  ".MuiStep-horizontal": {
                    borderTop: "4px solid",
                    paddingTop: "4px",
                    marginRight: "16px",
                  },
                  ".MuiStepIcon-root": {
                    fontSize: "100%",
                    marginLeft: "-10px",
                  },
                }}
              >
                <Step
                  style={{
                    width: "100%",
                    height: "4px",
                    borderColor: activeStep == 0 ? "rgb(200, 1, 125)" : "",
                  }}
                >
                  <StepLabel sx={{ width: "244px", height: "19px" }}>
                    {t("transferReason.navigation.generalInfo")}
                  </StepLabel>
                </Step>

                <Step
                  style={{
                    width: "100%",
                    height: "4px",
                    borderColor: activeStep == 1 ? "rgb(200, 1, 125)" : "",
                  }}
                >
                  <StepLabel sx={{ width: "244px", height: "19px" }}>
                    {t("transferReason.navigation.vehicle")}
                  </StepLabel>
                </Step>

                {formik.values.transferType === "DRIVER" && (
                  <Step
                    style={{
                      width: "100%",
                      height: "4px",
                      borderColor: activeStep == 2 ? "rgb(200, 1, 125)" : "",
                    }}
                  >
                    <StepLabel sx={{ width: "244px", height: "19px" }}>
                      {t("transferReason.navigation.drivers")}
                    </StepLabel>
                  </Step>
                )}
              </Stepper>
            </Stack>
          </Box>
        ) : (
          <Box sx={{ borderBottom: 1, borderColor: "#979797", mb: "16px" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              //aria-label="wrapped label tabs example"
            >
              <Tab
                value="generalInfo"
                label={t("transferReason.navigation.generalInfo")}
              />
              <Tab
                value="vehicle"
                label={t("transferReason.navigation.vehicle")}
              />
              <Tab
                value="driver"
                label={t("transferReason.navigation.drivers")}
              />
            </Tabs>
          </Box>
        )}

        <Card>
          <CardContent>
            {formik.values.id == "" ? createButton() : ""}
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default AddEditTransferReasonPage;
